<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Statistics") }}
        </div>
      </template>
      <v-row v-if="loading">
        <v-col>
          <v-progress-linear indeterminate></v-progress-linear>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-show="!this.filterFrom && !this.filterTo">
          <v-select
            v-model="filterYear"
            :items="filterSelects.years"
            :label="$t('year')"
          >
          </v-select>
        </v-col>
        <v-col>
          <v-text-field
            v-model="filterFrom"
            :label="$t('fromDate')"
            type="date"
          >
          </v-text-field>
        </v-col>
        <v-col>
          <v-text-field v-model="filterTo" :label="$t('toDate')" type="date">
          </v-text-field>
        </v-col>
        <v-col>
          <v-select
            v-model="filterCompany"
            :items="companies"
            item-text="name"
            item-value="id"
            :label="$t('Company')"
            clearable
          >
          </v-select
        ></v-col>
        <v-col>
          <v-select
            v-model="filterCategory"
            :items="categories"
            item-text="name"
            item-value="id"
            :label="$t('Typecategories')"
            clearable
          >
          </v-select>
        </v-col>
        <v-col>
          <v-select
            v-model="filterCountry"
            :items="countries"
            item-text="name"
            item-value="id"
            :label="$t('Countries')"
            clearable
          >
          </v-select>
        </v-col>
      </v-row>
      <template>
        <v-card>
          <v-card-title>
            Statistik pro Kunde Gesamt
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-if="items.companies"
              :items="items.companies"
              :headers="headers"
              class="elevation-1"
            >
            </v-data-table>
            <v-progress-linear indeterminate v-else></v-progress-linear>
          </v-card-text>
        </v-card>
      </template>
      <template>
        <v-card>
          <v-card-title>
            Statistik pro Typ
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-if="items.doorTypes"
              :items="items.doorTypes"
              :headers="headers"
              class="elevation-1"
            >
            </v-data-table>
            <v-progress-linear indeterminate v-else></v-progress-linear>
          </v-card-text>
        </v-card>
      </template>
      <template>
        <v-card>
          <v-card-title>
            Statistik pro Kategorie
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-if="items.categories"
              :items="items.categories"
              :headers="headers"
              class="elevation-1"
            >
            </v-data-table>
            <v-progress-linear indeterminate v-else></v-progress-linear>
          </v-card-text>
        </v-card>
      </template>

      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";
import { fetchItems as fetchCompanies } from "../../companies/shared/services";
import { fetchItems as fetchCountries } from "../../countries/shared/services";
import { fetchItems as fetchCategories } from "../../typeCategories/shared/services";
import axios from "axios";
import VComponent from "../../shared/components/template/base/VComponent.vue";

var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-statistic-list",
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "AnzahlGesamt",
          align: "left",
          value: "total"
        },
        { text: "", value: "action", sortable: false }
      ],
      loading: true,
      options: { page: -1 },
      total: 0,
      search: "",
      items: [],
      filterYear: "2021",
      filterFrom: null,
      filterTo: null,
      filterSelects: {
        years: ["2021", "2022", "2023", "2024", "2025", "2026"]
      },
      companies: [],
      filterCompany: null,
      countries: [],
      filterCountry: null,
      categories: [],
      filterCategory: null
    };
  },

  created() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;
      let response = await fetchItems(
        {
          ...this.options,
          search: this.search,
          year: this.filterYear,
          from: this.filterFrom,
          to: this.filterTo,
          company: this.filterCompany,
          category: this.filterCategory,
          country: this.filterCountry
        },
        new CancelToken(function executor(c) {
          cancel = c;
        })
      );
      this.items = response.data;
      this.total = response.meta.total;

      if (this.companies.length == 0) {
        let response2 = await fetchCompanies(
          {
            ...this.options
          },
          new CancelToken(function executor(c) {
            cancel = c;
          })
        );
        this.companies = response2.data;
      }

      if (this.countries.length == 0) {
        let response3 = await fetchCountries(
          {
            ...this.options
          },
          new CancelToken(function executor(c) {
            cancel = c;
          })
        );
        this.countries = response3.data;
      }

      if (this.categories.length == 0) {
        let response4 = await fetchCategories(
          {
            ...this.options
          },
          new CancelToken(function executor(c) {
            cancel = c;
          })
        );
        this.categories = response4.data;
      }

      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Statistic?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "statistic.edit", params: { id: url } });
    }
  },
  watch: {
    filterYear: {
      handler() {
        this.getData();
      },
      deep: true
    },
    filterFrom: {
      handler() {
        this.getData();
      },
      deep: true
    },
    filterTo: {
      handler() {
        this.getData();
      },
      deep: true
    },
    filterCompany: {
      handler() {
        this.getData();
      },
      deep: true
    },
    filterCategory: {
      handler() {
        this.getData();
      },
      deep: true
    },
    filterCountry: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
